'use client';

import buildShopSubdomainUrl from '@/utils/shopSubdomain';
import useLocale from '@/hooks/useLocale';
import React, { useMemo } from 'react';
import useCartContext from '@/context/CartContext';
import useFeature from '@/hooks/useFeature';

interface CartProps {
  cartText: string;
  classesText?: string;
  hoverStyleChange?: boolean;
}

export default function Cart({
  cartText,
  classesText,
  hoverStyleChange = true,
}: CartProps) {
  const { cart } = useCartContext();
  const quantity = cart?.totalQuantity;
  const locale = useLocale();
  const isNextJSCartEnabled = useFeature(
    'money_enable-cart-next-js-migration',
    'off',
  );

  const href = useMemo(() => {
    const cartUrl = locale.startsWith('en') ? '/cart' : `/${locale}/cart`;
    const href =
      isNextJSCartEnabled === 'treatment-page'
        ? cartUrl
        : buildShopSubdomainUrl('/cart', locale as string);

    return href;
  }, [locale, isNextJSCartEnabled]);

  return (
    // eslint-disable-next-line @next/next/no-html-link-for-pages
    <a
      className={`flex items-center self-center font-bold ${
        hoverStyleChange ? 'hover:text-indigo' : ''
      }`}
      href={href}
    >
      <span className={classesText || 'text-lg'}>{cartText}</span>
      <span className="ml-2 flex h-10 w-10 items-center justify-center rounded-full border border-current text-xl leading-8">
        {quantity}
      </span>
    </a>
  );
}
